module.exports = __webpack_public_path__ + "img/1532059520.82d35de6.jpg";